import type { TtqPathRunModelAudit } from '@kelilearning/psycheflow-contracts';

const LOBE_ICONS_BASE = 'https://registry.npmmirror.com/@lobehub/icons-static-png/latest/files';

export function getTtqImageModelIcon(): string {
  return `${LOBE_ICONS_BASE}/light/qwen-color.png`;
}

const MODEL_LABELS: Record<string, string> = {
  'deepseek-v4-pro': 'DeepSeek V4 Pro',
  'deepseek-v4-flash': 'DeepSeek V4 Flash',
  'deepseek-reasoner': 'DeepSeek V4 Pro',
  'deepseek-chat': 'DeepSeek V4 Flash',
  'qwen-plus': 'Qwen Plus',
  'qwen3.7-max': 'Qwen 3.7 Max',
  'qwen3.7-plus': 'Qwen3.7 Plus',
  'qwen3.6-plus': 'Qwen3.6 Plus',
  'qwen3.6-flash': 'Qwen3.6 Flash',
};

export function normalizeTtqModelId(model?: string | null): string {
  const raw = String(model || '').trim().toLowerCase();
  if (!raw) return '';
  if (raw === 'deepseek-reasoner') return 'deepseek-v4-pro';
  if (raw === 'deepseek-chat') return 'deepseek-v4-flash';
  return raw;
}

export function formatTtqModelLabel(model?: string | null): string {
  const id = normalizeTtqModelId(model);
  return MODEL_LABELS[id] || id || '—';
}

export function getTtqModelBrandIcon(provider?: string | null, model?: string | null): string | null {
  const p = String(provider || '').toLowerCase();
  const m = normalizeTtqModelId(model);
  if (p === 'deepseek' || m.includes('deepseek')) {
    return `${LOBE_ICONS_BASE}/light/deepseek-color.png`;
  }
  if (p === 'qwen' || m.includes('qwen')) {
    return `${LOBE_ICONS_BASE}/light/qwen-color.png`;
  }
  if (p === 'openai' || m.includes('gpt')) {
    return `${LOBE_ICONS_BASE}/light/openai.png`;
  }
  return null;
}

export function formatTtqModelAuditDisplay(audit?: {
  provider?: string | null;
  model?: string | null;
} | null): {
  label: string;
  iconUrl: string | null;
} | null {
  if (!audit?.provider && !audit?.model) return null;
  const modelId = normalizeTtqModelId(audit.model);
  return {
    label: formatTtqModelLabel(modelId),
    iconUrl: getTtqModelBrandIcon(audit.provider, modelId),
  };
}

/** 从颗粒 metadata 解析提取/工作台使用的模型 */
export function resolveParticleModelAudit(metadata: unknown): TtqPathRunModelAudit | null {
  if (!metadata || typeof metadata !== 'object') return null;
  const meta = metadata as Record<string, unknown>;
  const workbench = meta.ttqWorkbench && typeof meta.ttqWorkbench === 'object'
    ? meta.ttqWorkbench as Record<string, unknown>
    : null;
  const fromWorkbench = workbench?.modelAudit && typeof workbench.modelAudit === 'object'
    ? workbench.modelAudit as Record<string, unknown>
    : null;
  if (fromWorkbench?.model || fromWorkbench?.provider) {
    return {
      provider: String(fromWorkbench.provider || '').trim() || 'unknown',
      model: String(fromWorkbench.model || '').trim(),
      mode: fromWorkbench.mode as TtqPathRunModelAudit['mode'],
    };
  }

  const model = String(
    meta.model_used || meta.modelUsed || meta.model || '',
  ).trim();
  const provider = String(meta.provider || '').trim();
  if (!model && !provider) return null;
  return {
    provider: provider || (model.toLowerCase().includes('qwen') ? 'qwen' : 'unknown'),
    model: model || provider,
  };
}
